import { useEffect } from 'react';
import { useHistory } from './useHistory';
import { AvailableInstrument } from './mapInstruments';
import { useModalService } from './useModalService';

export const useDefaultTabEffect = (instruments: AvailableInstrument[]) => {
  const history = useHistory();

  const { isOpened } = useModalService();

  const enabledPathnames = instruments.map(({ pathname }) => pathname);

  useEffect(() => {
    if (!isOpened) {
      return;
    }

    const { pathname } = history.location;

    const actualPathname = pathname.replace(/\//g, '');

    // there is no enable tabs or some tab already selected
    if (!enabledPathnames.length || enabledPathnames.includes(actualPathname)) {
      return;
    }

    // use first tab by default
    history.push(`/${enabledPathnames[0]}`);
  }, [enabledPathnames.join(';')]);
};
